import { Injectable } from '@angular/core';
import Swal from 'sweetalert2'
import { Router } from '@angular/router'
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http'
declare var require: any;
var AmazonCognitoIdentity = require('amazon-cognito-identity-js');
import { environment } from 'src/environments/environment';
import { PublicService } from '../public/public.service';
import { StorageHelperService } from '../storageHelper/storage-helper.service';
import { MessagePopupService } from '../../../core/components/message-alert-popup/message-popup.service';
import { Button, Buttons, MessageType } from 'src/app/common/messagePopupModel';
import { apiConfig } from '../../apiConfig/apiConfig';
import { CoreHttpService } from '../../httpServices/core-http.service';
// import { SessionStorageHelperService } from '../session-storage-helper/session-storage-helper.service';


@Injectable({
  providedIn: "root",
})
export class AuthenticationServiceService {
  verificationFlag: boolean = false;
  loader: boolean = false;
  constructor(
    private router: Router,
    private http: HttpClient,
    private publicService: PublicService,
    private storageHelperService: StorageHelperService,
    private messagePopupService: MessagePopupService,
    private coreHttpService: CoreHttpService
  ) { }
  userpic;
  userName;
  poolData = {
    UserPoolId: environment.UserPoolId,
    ClientId: environment.ClientId,
  };

  async studentLogin(loginData) {
    if (
      loginData.value.username == null ||
      loginData.value.password == null ||
      loginData.value.username == ""
    ) {
      let dialog = this.messagePopupService.show(
        MessageType.Error,
        "Empty Data",
        "Please enter username and password",
        Buttons.Okay
      );
      dialog.dialogResult$.subscribe(() => {
        loginData.reset();
      });
    } else {
      if (false) {
      } else {
        let uname = loginData.value.username.replace(/\s/g, "");
        let password = loginData.value.password.replace(/\s/g, "");
        let authenticationData = { Username: uname, Password: password };
        let authenticationDetails =
          new AmazonCognitoIdentity.AuthenticationDetails(authenticationData);
        let userPool = new AmazonCognitoIdentity.CognitoUserPool(this.poolData);
        let userData = { Username: uname, Pool: userPool };
        let cognitoUser = new AmazonCognitoIdentity.CognitoUser(userData);

        return cognitoUser.authenticateUser(authenticationDetails, {
          onSuccess: async (result) => {
            if (loginData.value.deviceChecked == true) {
              cognitoUser.setDeviceStatusRemembered({
                onSuccess: function (result) {
                },
                onFailure: function (err) {
                  alert(err);
                },
              });
              cognitoUser.setDeviceStatusNotRemembered({
                onSuccess: function (result) {
                },
                onFailure: function (err) {
                  alert(err);
                },
              });
            }

            var idToken = result.idToken.jwtToken;
            this.storageHelperService.storeEncryptedData('idToken', JSON.stringify(idToken));
            const tokenPayload = await this.decodeJWTToken(idToken);
            if (tokenPayload["cognito:groups"] == "students") {
              if (tokenPayload["email_verified"] == false) {
                this.verificationFlag = true;
                await this.verifyUserAttributes(
                  tokenPayload,
                  cognitoUser,
                  "email",
                  "Email Id"
                );
              }
              // else if (tokenPayload["phone_number_verified"] == false) {
              //   this.verificationFlag = true;
              //   await this.verifyUserAttributes(tokenPayload, cognitoUser, 'phone_number', 'Phone number')
              // }
              else {
                if (this.verificationFlag) {
                  let profile = {
                    primaryEmail: tokenPayload.email,
                    mobile: tokenPayload.phone_number,
                  };
                  await (
                    await this.updateAllProfile(profile)
                  ).subscribe(
                    async (response) => {
                      await this.getUserProfile();
                      this.router.navigate(["/dashboard"]);
                    },
                    (error) => {
                      console.log(error);
                    }
                  );
                } else {
                  await this.getUserProfile();
                  this.router.navigate(["/dashboard"]);
                }
              }
            } else {
              let dialog = this.messagePopupService.show(
                MessageType.Info,
                "Invalid User",
                "You are not having access to this portal.",
                Buttons.Okay
              );
              dialog.dialogResult$.subscribe(() => {
                this.router.navigate(["/login"]);
              });
            }
          },
          onFailure: async (err) => {
            console.log("Login failed error is" + JSON.stringify(err));
            let dialog;
            switch (err.code) {
              case "UserNotFoundException":
                loginData.reset();
                dialog = this.messagePopupService.show(
                  MessageType.Error,
                  "Oops...",
                  "Username is not found",
                  Buttons.Okay
                );
                return;
              case "UserNotConfirmedException":
                loginData.reset();
                dialog = this.messagePopupService.show(
                  MessageType.Error,
                  "Oops...",
                  "This phone number is not confirmed. Please register again using this phone number",
                  Buttons.Okay
                );
                return;
              case "NotAuthorizedException":
                loginData.reset();
                dialog = this.messagePopupService.show(
                  MessageType.Error,
                  "Oops...",
                  err.message,
                  Buttons.Okay
                );
                return;
              case "NetworkError":
                loginData.reset();
                dialog = this.messagePopupService.show(
                  MessageType.Error,
                  "",
                  "Please check your internet",
                  Buttons.Okay
                );
                return;
              case "PasswordResetRequiredException":
                loginData.reset();
                dialog = this.messagePopupService.show(
                  MessageType.Error,
                  "Password Reset required",
                  "Please reset your password",
                  Buttons.Okay
                );
                return;
            }
          },
          newPasswordRequired: (userAttributes, requiredAttributes) => {
            (
              document.getElementById("newPasswordModel") as HTMLInputElement
            ).click();
            (
              document.getElementById("loginFormSection") as HTMLInputElement
            ).style.display = "none";
            (
              document.getElementById("newPassSection") as HTMLInputElement
            ).style.display = "block";
            // this.router.navigate(["/login/createNewPassword"])
          },
        });
      }
    }
  }

  async updateAllProfile(profile) {
    let userSnap = await this.getCurrentUser();
    let body = {
      ...profile,
      id: userSnap.studentId,
      studentId: userSnap.studentId,
    };
    return this.coreHttpService.putSecured(
      environment.baseUrl + apiConfig.authenticationApiUrls.student,
      body,
      { observe: "response" }
    );
  }

  async decodeJWTToken(token) {
    let base64Url = token.split(".")[1];
    let base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    let jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );
    return JSON.parse(jsonPayload);
  }

  async verifyUserAttributes(
    tokenPayload,
    cognitoUser,
    attributeType,
    attributeName
  ) {
    cognitoUser.getAttributeVerificationCode(attributeType, {
      onSuccess: async function (result) {
        if (result == "SUCCESS") {
          let dialog = this.messagePopupService.show(
            MessageType.Success,
            "Your Account Verified Successfully",
            "Please login now",
            Buttons.Okay
          );
        }
      },
      onFailure: function (err) {
        let dialog;
        console.log("Failure verification" + JSON.stringify(err));
        switch (err.code) {
          case "LimitExceededException":
            dialog = this.messagePopupService.show(
              MessageType.Error,
              "Limit exceeded",
              err.message,
              Buttons.Okay
            );
            break;
          case "CodeMismatchException":
            dialog = this.messagePopupService.show(
              MessageType.Error,
              "Invalid OTP",
              "Please enter valid OTP.",
              Buttons.Okay
            );
            break;
          case "ExpiredCodeException":
            dialog = this.messagePopupService.show(
              MessageType.Error,
              "OTP Expired",
              "Please try again",
              Buttons.Okay
            );
            break;
          default:
            dialog = this.messagePopupService.show(
              MessageType.Error,
              "Verification Failed",
              "Please try again",
              Buttons.Okay
            );
        }
      },
      inputVerificationCode: function (data) {
        Swal.fire({
          text:
            "Your " +
            attributeName +
            " is not verified. You will get an OTP in your registered " +
            attributeName +
            " " +
            "(" +
            data.CodeDeliveryDetails.Destination +
            ")",
          title: "Please enter the OTP",
          input: "text",
          inputAttributes: {
            autocapitalize: "off",
          },
          showCancelButton: true,
          confirmButtonText: "Verify",
          showLoaderOnConfirm: true,
          preConfirm: (otp) => {
            cognitoUser.verifyAttribute(attributeType, otp, this);
          },
          allowOutsideClick: () => !Swal.isLoading(),
        });
      },
    });
  }

  course_id;
  getUserProfile() {
    return new Promise(async (resolve, reject) => {
      const user = JSON.parse(this.storageHelperService.getDecryptData('studentProfile'));
      if (user) {
        resolve(user);
      } else {
        let userInfo = await this.getCurrentUser();
        let params = new HttpParams();
        params = params.append("studentId", userInfo.studentId);
        let response = this.coreHttpService.getSecured(
          environment.baseUrl + apiConfig.authenticationApiUrls.student,
          { params: params }
        );
        response.subscribe(async (userData) => {
          if (userData["academics"][0].collegeId) {
            const modifiedUserData = await this.storeUserSession(userData);
            await this.getConfiguration(userData["academics"][0].collegeId);
            await this.publicService.addAudit(
              userData["_id"],
              "login",
              "Student login",
              "login",
              userData["fullName"],
            );
            resolve(modifiedUserData);
          }
        });
      }
    })
  }


  async getConfiguration(collegeId) {
    let params = new HttpParams();
    params = params.append("collegeId", collegeId);
    this.coreHttpService
      .getSecured(
        environment.baseUrl +
        apiConfig.authenticationApiUrls.applicationConfiguration,
        { params: params }
      )
      .subscribe(
        (response) => {
          this.storageHelperService.storeEncryptedData(
            "studentConfiguration",
            JSON.stringify(response)
          );
        },
        async (error) => {
          console.log("Configuration error is" + JSON.stringify(error));
        }
      );
  }

  async getCloudFrontUrl(bucketUrl) {
    return (
      environment.cloudFrontUrl +
      bucketUrl?.[bucketUrl?.length - 3] +
      "/" +
      bucketUrl?.[bucketUrl?.length - 2] +
      "/" +
      bucketUrl?.[bucketUrl?.length - 1]
    );
  }

  /**
   * This function will check the session of the current logged in user and it will return the current user payload i.e token, username etc
   */
  async getCurrentUser() {
    try {
      let userPool = new AmazonCognitoIdentity.CognitoUserPool(this.poolData);
      let cognitoUser = userPool.getCurrentUser();
      if (cognitoUser != null) {
        return cognitoUser.getSession(async (err, session) => {
          if (session) {
            session.getRefreshToken();
            const tokenPayload = await this.decodeJWTToken(
              session.idToken.jwtToken
            );
            if (tokenPayload["cognito:groups"] != "students") {
              this.signOutUser();
            }
            let obj = Object();
            obj.token = session.idToken.jwtToken;
            obj.profilePicUrl = tokenPayload.picture;
            obj.studentId = tokenPayload["custom:_id"];
            obj.userName = tokenPayload["cognito:username"];
            obj.name = tokenPayload["given_name"];
            return obj;
          } else {
            this.loader = false;
            let dialog = this.messagePopupService.show(
              MessageType.Error,
              "Session Expired",
              "Your session expired please login again",
              Buttons.Okay
            );
            dialog.dialogResult$.subscribe(() => {
              this.storageHelperService.removeItem("studentProfile");
              this.router.navigate(["/login"]);
            });
          }
          if (err) {
            this.loader = false;
            console.log("Session error" + JSON.stringify(err));
            let dialog = this.messagePopupService.show(
              MessageType.Error,
              "Session Expired",
              "Your session expired please login again",
              Buttons.Okay
            );
            dialog.dialogResult$.subscribe(() => {
              this.storageHelperService.removeItem("studentProfile");
              this.router.navigate(["/login"]);
            });
          }
        });
      } else {
        this.loader = false;
        this.storageHelperService.removeItem("studentProfile");
        this.router.navigate(["/login"]);
      }
      //call refresh method in order to authenticate user and get new temp credentials
    } catch (error) {
      this.loader = false;
      console.log("catch error" + JSON.stringify(error));
    }
  }

  async storeUserSession(userData) {
    return new Promise(async (resolve, reject) => {
      const obj = Object(userData);
      obj.userId = userData?.["_id"];
      obj.collegeLogoUrl = await this.getCloudFrontUrl(
        userData?.["collegeLogo"].split("/")
      );
      obj.collegeName = userData?.["collegeName"];
      obj.userName = userData?.["fullName"];
      obj.userProfileUrl = await this.getCloudFrontUrl(
        userData?.["userThumbnailPath"].split("/")
      );
      obj.qualification = userData?.["qualification"];
      obj.collegeId = userData?.["academics"][0].collegeId;
      obj.courseId = userData?.["academics"][0].courseId;
      obj.courseName = userData?.["courseName"];
      obj.rollNumber = userData?.["rollNum"];
      this.storageHelperService.storeEncryptedData(
        "studentProfile",
        JSON.stringify(obj)
      );
      resolve(obj);
    });
  }

  async getUserSnap() {
    return new Promise(async (resolve, reject) => {
      let studentData = await this.getCurrentUser();
      let params = new HttpParams();
      // params = params.append("studentId", studentData.studentId);
      params = params.append('id', studentData.studentId);
      params = params.append('sid', studentData.studentId);
      const isUserData = JSON.parse(
        this.storageHelperService.getDecryptData("studentProfile")
      );
      if (isUserData) {
        resolve(isUserData);
      } else {
        const response = this.coreHttpService.getSecured(
          environment.baseUrl + apiConfig.authenticationApiUrls.student,
          { params: params }
        );
        response.subscribe(
          async (userData: any) => {
            const modifiedUserData = await this.storeUserSession(userData);
            resolve(modifiedUserData);
          },
          async (error) => {
            reject(error);
          }
        );
      }
    });
  }

  /**
   * This function will change the current password of the user
   * @param passwordsInfo contains current password and the new password
   */
  async changeCurrentPassword(passwordsInfo) {
    let currentPassword = passwordsInfo.value.currentPassword.replace(
      /\s/g,
      ""
    );
    let newPassword = passwordsInfo.value.newPassword.replace(/\s/g, "");
    let currentUserData = await this.getCurrentUser();
    let userPool = new AmazonCognitoIdentity.CognitoUserPool(this.poolData);
    let userData = { Username: currentUserData.userName, Pool: userPool };
    let cognitoUser = new AmazonCognitoIdentity.CognitoUser(userData);
    let authenticationData = {
      Username: currentUserData.userName,
      Password: currentPassword,
    };
    let authenticationDetails = new AmazonCognitoIdentity.AuthenticationDetails(
      authenticationData
    );
    return cognitoUser.authenticateUser(authenticationDetails, {
      onSuccess: (session) => {
        if (session) {
          return cognitoUser.changePassword(
            currentPassword,
            newPassword,
            async (err, result) => {
              console.log("Change Password Error is" + JSON.stringify(err));
              if (err) {
                if (err.code == "InvalidPasswordException") {
                  let dialog = this.messagePopupService.show(
                    MessageType.Error,
                    "Invalid New Password",
                    "Please follow the password policy",
                    Buttons.Okay
                  );
                } else {
                  let dialog = this.messagePopupService.show(
                    MessageType.Error,
                    "Failed to change password",
                    "Please try again",
                    Buttons.Okay
                  );
                }
              }
              if (result) {
                if (result == "SUCCESS") {
                  let dialog = this.messagePopupService.show(
                    MessageType.Success,
                    "Your new password is updated successfully",
                    "",
                    Buttons.Okay
                  );
                  dialog.dialogResult$.subscribe(() => {
                    passwordsInfo.reset();
                  });
                }
              }
            }
          );
        }
      },
      onFailure: (err) => {
        if (err.code == "NotAuthorizedException") {
          let dialog = this.messagePopupService.show(
            MessageType.Error,
            "Invalid current password",
            "Please enter valid password",
            Buttons.Okay
          );
        }
      },
    });
  }

  async changeCurrentPhone(phoneInfo) {
    let userSnap = await this.getCurrentUser();
    let body = {
      studentId: userSnap.studentId,
      id: userSnap.studentId,
      mobile: phoneInfo.value.newPhone,
    };
    let response = this.coreHttpService.putSecured(
      environment.baseUrl + apiConfig.authenticationApiUrls.student,
      body
    );
    return response.subscribe(
      async (data) => {
        this.loader = false;
        let dialog = this.messagePopupService.show(
          MessageType.Success,
          "Your phone number is changed successfully",
          "",
          Buttons.Okay
        );
        dialog.dialogResult$.subscribe(() => {
          phoneInfo.reset();
        });
      },
      (error) => {
        this.loader = false;
        let dialog = this.messagePopupService.show(
          MessageType.Error,
          "Failed to change Phone",
          "Please try again",
          Buttons.Okay
        );
      }
    );
  }

  async changeCurrentEmail(emailInfo) {
    let userSnap = await this.getCurrentUser();
    let body = {
      studentId: userSnap.studentId,
      id: userSnap.studentId,
      primaryEmail: emailInfo,
    };
    let response = this.coreHttpService.putSecured(
      environment.baseUrl + apiConfig.authenticationApiUrls.student,
      body
    );
    return response.subscribe(
      async (data) => {
        this.loader = false;
        let dialog = this.messagePopupService.show(
          MessageType.Success,
          "Your Email is changed successfully",
          "",
          Buttons.Okay
        );
        dialog.dialogResult$.subscribe(() => {
          emailInfo.reset();
        });
      },
      (error) => {
        console.log(
          "changeCurrentEmail Func error response" + JSON.stringify(error)
        );
        this.loader = false;
        let dialog = this.messagePopupService.show(
          MessageType.Error,
          "Failed to change Email",
          "Please try again",
          Buttons.Okay
        );
      }
    );
  }

  /**
   * This function will signout the user and
   */
  async signOutUser() {
    var userPool = new AmazonCognitoIdentity.CognitoUserPool(this.poolData);
    var cognitoUser = userPool.getCurrentUser();
    const userProfile : any = await this.getUserProfile()
    if (cognitoUser != null) {
      let dialog = this.messagePopupService.show(
        MessageType.Success,
        "Sign Out",
        "Are you sure?",
        Buttons.YesCancel
      );

      dialog.dialogResult$.subscribe(async (result) => {
        if (Button[result] === "Yes") {
          await this.publicService.addAudit(
            userProfile?._id,
            "logout",
            "Student logout",
            "logout",
            userProfile?.fullName
          );
          this.storageHelperService.clearSession();
          cognitoUser.signOut();
          this.router.navigate(["/login"]);
        }
      });
    }
  }

  /**
   * This function will take username as parameter to handle forgot password
   * @param userInfo conatins the current logged in username
   */
  async handleForgotPassword(userInfo) {
    let username = userInfo.value.username.replace(/\s/g, "");
    var userPool = new AmazonCognitoIdentity.CognitoUserPool(this.poolData);
    this.userName = username;
    var userData = { Username: username, Pool: userPool };
    var cognitoUser = new AmazonCognitoIdentity.CognitoUser(userData);
    return new Promise((resolve, reject) => {
      cognitoUser.forgotPassword({
        onSuccess(result) {
          resolve(result);
        },
        onFailure(err) {
          reject(err);
          console.log("Forgot password failed", JSON.stringify(err));
        },
      });
    });
  }

  confirmPassword(user: String, verificationCode: String, newPassword: String) {
    const username = user.replace(/\s/g, "");
    const userPool = new AmazonCognitoIdentity.CognitoUserPool(this.poolData);
    const userData = { Username: username, Pool: userPool };
    const cognitoUser = new AmazonCognitoIdentity.CognitoUser(userData);
    return new Promise((resolve, reject) => {
      cognitoUser.confirmPassword(verificationCode, newPassword, {
        onFailure(err) {
          reject(err);
        },
        onSuccess(data) {
          resolve(data);
        },
      });
    });
  }

  /**
   * Function will create a new password at first login of the user
   * @param newPassword  New password entered by the user
   * @param currentCredential  it is an object which contains username and current password of the user
   */
  changePasswordFirstLogin(newPass, currentCredential) {
    let username = currentCredential.username.replace(/\s/g, "");
    let currentPassword = currentCredential.password.replace(/\s/g, "");
    let newPassword = newPass.value.password.replace(/\s/g, "");
    let authenticationData = { Username: username, Password: currentPassword };
    let authenticationDetails = new AmazonCognitoIdentity.AuthenticationDetails(
      authenticationData
    );
    let userPool = new AmazonCognitoIdentity.CognitoUserPool(this.poolData);
    let userData = { Username: username, Pool: userPool };
    let cognitoUser = new AmazonCognitoIdentity.CognitoUser(userData);
    return cognitoUser.authenticateUser(authenticationDetails, {
      newPasswordRequired: (userAttributes, requiredAttributes) => {
        let attributesData = {};
        return cognitoUser.completeNewPasswordChallenge(
          newPassword,
          attributesData,
          {
            onSuccess: (result) => {
              if (result) {
                (<HTMLInputElement>(
                  document.getElementById("close-changepass-button")
                )).click();
                let dialog = this.messagePopupService.show(
                  MessageType.Success,
                  "",
                  "Password changed successfully,Login again using your new password",
                  Buttons.Okay
                );
                dialog.dialogResult$.subscribe(() => {
                  (
                    document.getElementById(
                      "loginFormSection"
                    ) as HTMLInputElement
                  ).style.display = "block";
                  (
                    document.getElementById(
                      "newPassSection"
                    ) as HTMLInputElement
                  ).style.display = "none";
                  this.router.navigate(["/login"]);
                  newPass.reset();
                });
              }
            },
            onFailure: (error) => {
              console.log(
                "Change password first time error" + JSON.stringify(error)
              );
              if (error.code == "InvalidPasswordException") {
                let dialog = this.messagePopupService.show(
                  MessageType.Success,
                  "Password error",
                  "Password should contain minimum 8 characters including Uppercase,lowercase,numbers,special characters(ex:@)",
                  Buttons.Okay
                );
                dialog.dialogResult$.subscribe(() => {
                  (<HTMLInputElement>(
                    document.getElementById("close-changepass-button")
                  )).click();
                  newPass.reset();
                });
              }
            },
          }
        );
      },
    });
  }

  async getStudentPermissions() {
    let userSnap = await this.getCurrentUser();
    let params = new HttpParams().set("studentId", userSnap.studentId);
    return this.coreHttpService.getSecured(
      environment.baseUrl + apiConfig.authenticationApiUrls.emailPreference,
      { observe: "response", params: params }
    );
  }

  async updatePermission(permissionObj) {
    let userSnap = await this.getCurrentUser();
    let params = new HttpParams().set("studentId", userSnap.studentId);
    /* let body = {
      preferences: permissionObj
    } */
    return this.coreHttpService.putSecured(
      environment.baseUrl + apiConfig.authenticationApiUrls.emailPreference,
      permissionObj,
      { observe: "response", params: params }
    );
  }
}
